import styled, { css } from 'styled-components';
import { prop } from 'ramda';
import { Link } from 'gatsby';

import { Color, FontWeight } from '../../theme';
import { styleWhenTrue } from '../../utils';

import { TextLogoData } from './companyLogo.types';

export const TextLogo = styled.div<TextLogoData>`
  color: ${Color.primary};
  font-size: 37px;
  font-weight: ${FontWeight.Bold};
  letter-spacing: 0.15px;
  text-decoration: none;
  ${styleWhenTrue(prop('isLightVersion'), css`
    color: ${Color.white};
  `)}
`;

export const ImageLogo = styled.img`
  max-width: 100%;
`;

export const LocalLink = styled(Link)`
  text-decoration: none;
`;
